<script lang="ts">
	import { browser } from '$app/environment';
	import { X } from '@lucide/svelte';
	import { onMount } from 'svelte';

	let {
		text,
		link,
		cta,
		visible: initialVisible,
		closeBtn
	}: {
		text: string;
		link: string;
		cta: string;
		visible: boolean;
		closeBtn: boolean;
	} = $props();

	let visible = $derived(initialVisible);

	onMount(() => {
		if (browser && sessionStorage.getItem('notif-bar-dismissed') === '1') {
			visible = false;
		}
	});

	function dismiss() {
		visible = false;
		sessionStorage.setItem('notif-bar-dismissed', '1');
	}
</script>

{#if visible}
	<div class="relative z-[60] w-full bg-juslin-gold px-4 py-2.5">
		<div class="container mx-auto flex items-center justify-center gap-3">
			<p class="text-center text-xs font-semibold text-juslin-black sm:text-sm">
				{text} —
				<a href={link} class="underline underline-offset-2 hover:opacity-70">
					{cta}
				</a>
			</p>
			{#if closeBtn}
				<button
					onclick={dismiss}
					aria-label="Fermer"
					class="absolute top-1/2 right-3 mr-2 -translate-y-1/2 cursor-pointer rounded-full p-2 hover:bg-juslin-black/10"
				>
					<X class="h-3.5 w-3.5 text-juslin-black" />
				</button>
			{/if}
		</div>
	</div>
{/if}
